module.exports = __webpack_public_path__ + "img/ff5add2255149ce4e17c56d39e1ef24b.png";